define("settings/templates/overview/index", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldShowPlanRecommendation}}
    <PlanRecommendation @onClose={{this.dismissPlanRecommendation}} />
  {{/if}}
  */
  {
    "id": "YPAptMjN",
    "block": "[[[41,[30,0,[\"shouldShowPlanRecommendation\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@onClose\"],[[30,0,[\"dismissPlanRecommendation\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"plan-recommendation\"]]",
    "moduleName": "settings/templates/overview/index.hbs",
    "isStrictMode": false
  });
});